import { NgClass } from '@angular/common';
import { Component, input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ToastrService } from '@shared-angular/services/toastr.service';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { SupervisorThreadBroadcastService } from '../supervisor-threads/supervisor-thread-broadcast.service';
import { SupervisorService } from '../supervisor.service';

@Component({
  selector: 'app-supervisor-prompt-input',
  imports: [NgClass, FormsModule, InputTextModule, ButtonModule],
  templateUrl: './supervisor-prompt-input.component.html',
  styleUrl: './supervisor-prompt-input.component.scss'
})
export class SupervisorPromptInputComponent {
  public readonly disabled = input<boolean>(true);
  protected promptInput: string = '';
  constructor(public supervisorService: SupervisorService, public threadBroadcastService: SupervisorThreadBroadcastService, private toastr: ToastrService) { }

  protected async onKey(e: KeyboardEvent) {
    if (e.key === "Enter" && !e.shiftKey) {
      await this.sendPrompt();
    }
  }

  public getPlaceholder() {
    const activeChats = this.threadBroadcastService.selectedThreadsSet.size - this.threadBroadcastService.inactiveThreadCount();
    if (this.supervisorService.selectedThread !== undefined) {
      if (activeChats == 0) {
        return $localize`:@@enter-message-here:Nachricht eingeben`;
      }
    }
    if (activeChats == 0) return $localize`:@@chats-offline-selected:Chat(s) offline`;
    if (activeChats == 1) return $localize`:@@send-to-one-chats-:Nachricht an 1 Chat senden`;
    return $localize`:@@send-to-N-chats-:Nachricht an ${activeChats} Chats senden`;
  }

  protected async sendPrompt() {
    if (this.threadBroadcastService.selectedThreadsSet.size == 0) {
      const response = await this.supervisorService.sendAdminMessage(this.promptInput);
      if (!response) return;
    } else {
      this.threadBroadcastService.broadcastSupervisorPrompt(this.promptInput);
    }
    this.promptInput = "";
    this.toastr.success('GENERAL', $localize`:@@message-sent:Nachricht gesendet`);
    await this.supervisorService.scrollDown();
  }
}
